/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import dayjs from 'dayjs';

/**
 * Customer useUserForm hook
 * @returns {{isUnderage: boolean}}
 */
export function useUserForm() {
  const { values } = useFormikContext();
  const [isUnderage, setIsUnderage] = useState(false);

  /**
     * Check if the user is under 18 years old
     */
  useEffect(() => {
    if (values.dateOfBirth) {
      const dateBefore18Years = dayjs().subtract(18, 'year');
      if (dateBefore18Years.isBefore(dayjs(values.dateOfBirth))) {
        setIsUnderage(true);
      } else {
        setIsUnderage(false);
      }
    }
  }, [values.dateOfBirth]);

  return {
    isUnderage,
  };
}
